module.exports = __webpack_public_path__ + "static/media/fMINUTA AFECTACION A VIVIENDA FAMILIAR FINAL.b17ba147.pdf";